import { ELECTION_FIELD_DATA } from '~/consts/generalSettings';
import { ElectionAttribute } from '~/definitions/election';

function getSelectedElectionAttribute(attributes: ElectionAttribute[], number?: string) {
    let attribute: ElectionAttribute = {};
    const field = ELECTION_FIELD_DATA[number as string];

    const attributeFiltered = attributes?.filter((attr: ElectionAttribute) => {
        return attr.number === field.name;
    });
    attribute = attributeFiltered?.[0] || {};

    return attribute;
}

export default getSelectedElectionAttribute;
